import InfoIcon from "@mui/icons-material/Info";
import { Box } from "@mui/material";
import AcxChip from "components/UI/AcxChip";
import React from "react";
import theme from "Theme/AppTheme";

/**
 * Marks a surface that still works but is on its way out, so a user can tell it apart from the
 * replacement sitting next to it.
 *
 * `infoText` is the optional hover explanation — usually what to use instead, since the tag alone
 * says a surface is going away without saying where to go. Omit it and the chip renders bare, with
 * no tooltip and no info icon, since the icon promises a tooltip that would never come.
 *
 * Kept as its own component rather than a prop on a shared tag so the three statuses can diverge
 * visually without touching every call site. See {@link AcxNewTag} and {@link AcxBetaTag}.
 */
export const AcxDeprecatedTag = ({ infoText }: { infoText?: string }) => (
    <AcxChip
        size="small"
        color="gray"
        label={
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: 0.5,
                }}
            >
                Deprecated
                {!!infoText && (
                    <InfoIcon sx={{ fontSize: 14, color: "inherit" }} />
                )}
            </Box>
        }
        customTooltip={infoText}
        sx={{
            marginBottom: 0,
            backgroundColor: theme.palette.gray[200],
            color: theme.palette.neutral.dark,
        }}
    />
);

export default AcxDeprecatedTag;
